import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import {
  List, ListItem, ListItemText
} from '@material-ui/core';
import { I18n } from 'src/translations/i18n';

const useStyles = makeStyles(({ palette }) => ({
  icon: {
    height: 18,
    width: 26
  },
  langSelect: {
    padding: 0
  },
  item: {
    cursor: 'pointer'
  },
  themeColor: {
    width: 32,
    height: 32,
    borderRadius: '50%',
    border: '3px solid',
    overflow: 'hidden',
    marginRight: 16
  },
  lightOrange: {
    background: '#E66950',
    borderColor: '#F2F2F2'
  },
  lightBlue: {
    background: '#546E7A',
    borderColor: '#CCD6ED'
  },
  darkOrange: {
    background: '#E66950',
    borderColor: '#424242'
  }
}));

const themes = ['lightOrange', 'lightBlue', 'darkOrange'];

function ThemeSelect({ changeTheme, themeType }) {
  const classes = useStyles();

  return (
    <List className={classes.langSelect}>
      {themes.map((theme) => (
        <ListItem
          key={theme}
          onClick={() => changeTheme(theme)}
          selected={themeType === theme}
          className={classes.item}
        >
          <div className={`${classes.themeColor} ${classes[theme]}`} />
          <ListItemText primary={I18n.t(theme)} />
        </ListItem>
      ))}
    </List>
  );
}

ThemeSelect.propTypes = {
  changeTheme: PropTypes.func.isRequired,
  themeType: PropTypes.string.isRequired
};

export default ThemeSelect;
